import { useEffect, useState } from 'react'

import {
  Box,
  Button,
  CheckBox,
  Input,
  Modal,
  Text,
} from '@fairfashion/design-system'
import { useForm } from 'react-hook-form'

import {
  CompanyContactForm,
  EditCompanyContactModalProps,
} from './edit-company-contact-modal.types'

export const EditCompanyContactModal = ({
  data,
  open,
  onClose,
  onSubmit,
}: EditCompanyContactModalProps) => {
  const [consent, setConsent] = useState(false)

  const { register, reset, handleSubmit } = useForm<CompanyContactForm>()

  useEffect(() => {
    if (data && open) {
      reset({
        name: data.name,
        email: data.email,
      })
    }
  }, [open])

  const submitForm = async (data: CompanyContactForm) => {
    if (onSubmit) {
      await onSubmit(data)
      onClose()
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Editar Contato"
      width="830px"
      maxWidth="90%"
    >
      <form onSubmit={handleSubmit(submitForm)}>
        <Box width="100%" direction="column" gap={2}>
          <Text size="small" fontWeight={500}>
            Contato
          </Text>

          <Box width="100%">
            <Input {...register('name')} label="Nome do Responsável" disabled />
          </Box>
          <Box width="100%">
            <Input {...register('email')} label="Email" disabled />
          </Box>
          <Box width="100%">
            <CheckBox
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              label="Declaro que os dados são verdadeiros e me responsabilizo pelas informações aqui contidas."
            />
          </Box>

          <Box width="100%" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" disabled={!consent}>
              Salvar
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  )
}
